import React, { useEffect, useState } from 'react';
import VoteCardComponent from '../components/Vote_card_component';
import "../styles/vote.css"

export default function Voting({ addToast }) {
    const [matches, setMatches] = useState([])


    //STATISZTIKAI ADATOK
    const [stats, setStats] = useState({})

    //Szavazatok
    const [vote1x2, setVote1x2] = useState(null);
    const [voteBtts, setVoteBtts] = useState(null);
    const [voteOver25, setVoteOver25] = useState(null);
    const [voteCards, setVoteCards] = useState(null);


    //TITLE, META TAG BEÁLLITÁS
    useEffect(() => {
        document.title = "Ki nyer ma? – Napi foci tippjáték és közösségi tippek | FociFanatik";

        const meta = document.querySelector("meta[name='description']");
        if (meta) {
            meta.setAttribute(
                "description",
                "Szavazz a mai focimeccsekre! Nézd meg, szerinted ki nyer ma, és hasonlítsd össze a közösségi tippeket statisztikákkal."
            );
        }
    }, []);



    //SZAVAZÁS LEADÁSA
    const saveVote = (matchId) => {
        fetch("https://focifanatik.hu/api/add_vote.php", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            credentials: "include",
            body: JSON.stringify({
                match_id: matchId,
                goal_over_under: voteOver25,
                both_team_score: voteBtts,
                home_x_away: vote1x2,
                cards_over_under: voteCards
            }),
        })
            .then((res) => res.json())
            .then((data) => {
                if (data.success) {
                    addToast("Sikeresen leadtad a szavazatodat!", "success")

                    fetch(`https://focifanatik.hu/api/vote_stats.php?id=${matchId}`)
                        .then(res => res.json())
                        .then(statData => {
                            setStats(prev => ({
                                ...prev,
                                [matchId]: statData
                            }));
                        });
                }
                else {
                    addToast(data.error, "warning")
                }
            })
            .catch(() => {
                addToast("Már le adtad a szavazatod erre mérkőzésre!", "warning");
            });


        setVote1x2(null);
        setVoteBtts(null);
        setVoteOver25(null);
        setVoteCards(null);

    }

    //MECCSEK BETÖLTÉSE
    useEffect(() => {
        fetch("https://focifanatik.hu/api/vote_matches.php")
            .then((response) => response.json())
            .then((data) => {
                console.log("Kapott adatok:", data); // ← ezzel látod a böngésző konzolban, hogy tényleg jön adat
                if (Array.isArray(data)) {
                    setMatches(data);
                } else {
                    setMatches([]); // ha nem tömb jön vissza, akkor üres tömb
                }
            })
            .catch((err) => console.error("Hiba a lekéréskor:", err));
    }, []);



    return (
        <div className='vote-bg'>
            {matches.length === 0 ? (
                <div className="stats-empty">
                    <div className="stats-empty-card">

                        <h2>Nincs még elérhető mérkőzés, nézz vissza később</h2>

                        <p>
                            A mai mérkőzések statisztikái még feldolgozás alatt vannak.
                            Az adatok automatikusan frissülnek, amint elérhetőek lesznek.
                        </p>

                    </div>
                </div>
            ) : (
                <div className='mt-3'>
                    {matches.map((m) => (
                        <VoteCardComponent
                            key={m.id}
                            addToast={addToast}
                            match={m}

                            stats={stats[m.id]}
                            setStats={setStats}

                            vote1x2={vote1x2}
                            setVote1x2={setVote1x2}

                            voteBtts={voteBtts}
                            setVoteBtts={setVoteBtts}

                            voteOver25={voteOver25}
                            setVoteOver25={setVoteOver25}

                            voteCards={voteCards}
                            setVoteCards={setVoteCards}

                            saveVote={saveVote}
                        />
                    ))}
                </div>
            )}
        </div>
    )
}